export const FACET_ZONES = {
  first: ['category', 'brand'],
  automatic: ['availability', 'color', 'size', 'material', 'price'],
  last: [],
  hidden: ['condition'],
};

export const FACETS = {
  category: {
    id: 'category',
    key: 'category',
    title: 'Category',
    type: 'string',
    typeLabel: 'List',
    values: 48,
    products: 7823,
    summary: 'Shop categories',
    health: 'ready',
  },
  brand: {
    id: 'brand',
    key: 'manufacturer',
    title: 'Brand',
    type: 'string',
    typeLabel: 'List',
    values: 27,
    products: 7610,
    summary: 'Manufacturer names',
    health: 'ready',
  },
  availability: {
    id: 'availability',
    key: 'available_for_order',
    title: 'Availability',
    type: 'boolean',
    typeLabel: 'Boolean',
    values: 7,
    products: 7823,
    summary: 'Mapped from catalog availability',
    health: 'attention',
    issue: '2 values are not assigned',
  },
  color: {
    id: 'color',
    key: 'feature.color',
    title: 'Body color',
    type: 'color',
    typeLabel: 'Color',
    values: 36,
    products: 6198,
    summary: '12 customer-facing colors',
    health: 'ready',
  },
  size: {
    id: 'size',
    key: 'attribute.size',
    title: 'Size',
    type: 'string',
    typeLabel: 'Grouped list',
    values: 31,
    products: 5340,
    summary: '8 grouped sizes · 3 unassigned',
    health: 'ready',
  },
  material: {
    id: 'material',
    key: 'feature.material',
    title: 'Material',
    type: 'string',
    typeLabel: 'List',
    values: 19,
    products: 4880,
    summary: 'Catalog values pass through',
    health: 'ready',
  },
  price: {
    id: 'price',
    key: 'price',
    title: 'Price',
    type: 'number',
    typeLabel: 'Range',
    values: 7823,
    products: 7823,
    summary: 'Validated 12 minutes ago',
    health: 'ready',
  },
  condition: {
    id: 'condition',
    key: 'condition',
    title: 'Condition',
    type: 'string',
    typeLabel: 'List',
    values: 4,
    products: 7823,
    summary: 'New, used and refurbished',
    health: 'ready',
  },
};

export const TYPE_OPTIONS = [
  { id: 'string', title: 'List', description: 'Names, brands, sizes and other labels' },
  { id: 'boolean', title: 'Boolean', description: 'Two customer-facing choices' },
  { id: 'color', title: 'Colors', description: 'Named swatches assembled from catalog values' },
  { id: 'number', title: 'Number range', description: 'Price, dimensions and other numeric values' },
];

export const BOOLEAN_VALUES = [
  { id: 'in_stock', label: 'In stock', count: 5821, lane: 'yes' },
  { id: 'available', label: 'Available', count: 1402, lane: 'yes' },
  { id: '1', label: '1', count: 510, lane: 'yes' },
  { id: 'out_of_stock', label: 'Out of stock', count: 972, lane: 'no' },
  { id: 'unavailable', label: 'Unavailable', count: 304, lane: 'no' },
  { id: 'preorder', label: 'Pre-order', count: 125, lane: 'unassigned' },
  { id: 'on_request', label: 'On request', count: 89, lane: 'unassigned' },
];

export const COLOR_GROUPS = [
  {
    id: 'neutral-light',
    label: 'White & cream',
    color: '#eee9df',
    values: [
      { id: 'white', label: 'White', count: 731 },
      { id: 'ivory', label: 'Ivory', count: 184 },
      { id: 'cream', label: 'Cream', count: 422 },
    ],
  },
  {
    id: 'neutral-dark',
    label: 'Black & charcoal',
    color: '#33363d',
    values: [
      { id: 'black', label: 'Black', count: 918 },
      { id: 'graphite', label: 'Graphite', count: 344 },
      { id: 'charcoal', label: 'Charcoal', count: 291 },
    ],
  },
  {
    id: 'blue',
    label: 'Blue',
    color: '#426aa3',
    values: [
      { id: 'navy', label: 'Navy blue', count: 437 },
      { id: 'sky', label: 'Sky blue', count: 211 },
      { id: 'petrol', label: 'Petrol blue', count: 102 },
    ],
  },
];

export const UNGROUPED_COLORS = [
  { id: 'taupe', label: 'Taupe', count: 277 },
  { id: 'natural-oak', label: 'Natural oak', count: 193 },
  { id: 'multi', label: 'Multicolour', count: 88 },
  { id: 'transparent', label: 'Transparent', count: 41 },
];

export const STRING_GROUPS = [
  {
    id: 'compact',
    label: 'Compact',
    values: [
      { id: 'xs', label: 'XS', count: 382 },
      { id: 'small', label: 'Small', count: 741 },
      { id: 's', label: 'S', count: 636 },
    ],
  },
  {
    id: 'standard',
    label: 'Standard',
    values: [
      { id: 'medium', label: 'Medium', count: 1042 },
      { id: 'm', label: 'M', count: 829 },
      { id: 'regular', label: 'Regular', count: 228 },
    ],
  },
  {
    id: 'large',
    label: 'Large',
    values: [
      { id: 'large-value', label: 'Large', count: 944 },
      { id: 'l', label: 'L', count: 811 },
      { id: 'xl', label: 'XL', count: 534 },
    ],
  },
];

export const UNGROUPED_STRINGS = [
  { id: 'one-size', label: 'One size', count: 330 },
  { id: '120-cm', label: '120 cm', count: 84 },
  { id: '2-seater', label: '2 seater', count: 61 },
];

export const VALUE_ORDER = [
  { id: 'black', label: 'Black & charcoal', count: 1553, pinned: true, hidden: false },
  { id: 'white', label: 'White & cream', count: 1337, pinned: true, hidden: false },
  { id: 'blue', label: 'Blue', count: 750, pinned: false, hidden: false },
  { id: 'green', label: 'Green', count: 524, pinned: false, hidden: false },
  { id: 'red', label: 'Red', count: 408, pinned: false, hidden: false },
  { id: 'yellow', label: 'Yellow', count: 219, pinned: false, hidden: false },
  { id: 'multi', label: 'Multicolour', count: 88, pinned: false, hidden: true },
];

export const NUMBER_REPORT = {
  total: 7823,
  valid: 7809,
  invalid: 14,
  min: 19.9,
  max: 6899,
  examples: [
    { value: 'Price on request', products: 8 },
    { value: 'from €499', products: 4 },
    { value: '', products: 2 },
  ],
};
